import React from 'react';
import { FilmmakerAnimatedSidebar } from './FilmmakerAnimatedSidebar';
import { UnifiedAnimatedSidebar } from './UnifiedAnimatedSidebar';
import { useTheme } from '@/hooks/use-theme';
import { useAuth } from '@/contexts/AuthContext';
import Container from '@/components/ui/Container';
import { GlobalHeader } from './GlobalHeader';
import { DownloadAppBanner } from '@/components/app-promo/DownloadAppBanner';

interface DashboardLayoutProps {
  children: React.ReactNode;
  /** Hide the global header (for pages that manage their own header) */
  hideHeader?: boolean;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({
  children,
  hideHeader = false,
}) => {
  const { theme } = useTheme();
  const { userType } = useAuth();
  const isDual = userType === 'both';

  return (
    <div
      className={`flex flex-col md:flex-row w-full h-screen overflow-hidden bg-sidebar ${theme}`}
    >
      {isDual ? <UnifiedAnimatedSidebar /> : <FilmmakerAnimatedSidebar />}
      <div className="flex-1 flex flex-col overflow-hidden min-h-0">
        {/* Global Header - with rounded corner to curve around sidebar */}
        {!hideHeader && (
          <GlobalHeader className="md:rounded-tl-[1.75rem] md:border-l md:border-t md:border-border" dashboardType="filmmaker" />
        )}

        <main className={`
          flex-1 min-h-0 overflow-y-auto relative bg-background md:border-l md:border-b md:border-r md:border-border p-4 md:p-6
          ${hideHeader ? 'md:rounded-tl-[1.75rem] md:border-t' : ''}
        `}>
          <DownloadAppBanner />
          <Container>{children}</Container>
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
